export default __webpack_public_path__ + "static/top_logos_2-8e7b7924bf9f2ae5d5164d51a9c58102.png";